











import Vue from 'vue';
import Component from 'vue-class-component';
import UserList from '@/components/UserList.vue';
import { User } from '../types';

// TODO: Remove this. Views shouldn't talk directly to services.
import UserService from '../services/userService';

@Component({
  components: {
    UserList
  }
})
export default class Users extends Vue {
  public users: User[] | null = null;

  // TODO: Remove this. Views shouldn't talk directly to services.
  public userService: UserService | null = null;

  public mounted() {
    this.userService = new UserService();
    this.userService.fetchUsers()
      .then((foundUsers) => {
        this.users = foundUsers;
        console.log(`Found users: ${JSON.stringify(foundUsers)}`);
      });
  }
}
